import { actionTypes } from "actions/domains/actionTypes";
import { actionTypes as deployAppActionTypes } from "actions/account/actionTypes";

type TSelectedDNSProviders =
  | "Squarespace"
  | "Wix"
  | "GoDaddy"
  | "Other";

type TSTate = {
  connectCurrentDomain: {
    step: number;
    helpInstructionsVisibility: boolean;
    selectedDNSProvider: TSelectedDNSProviders;
    domainName: "";
    isSubmitting: boolean;
    isSubmitted: boolean;
  };
};

const initState: TSTate = {
  connectCurrentDomain: {
    step: 0,
    helpInstructionsVisibility: false,
    selectedDNSProvider: "Squarespace",
    domainName: "",
    isSubmitting: false,
    isSubmitted: false,
  },
};

const domainReducer = (state = initState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.INCREMENT_CONNECT_CURRENT_DOMAIN_STEP:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          step: state.connectCurrentDomain.step + 1,
        },
      };
    case actionTypes.DECREMENT_CONNECT_CURRENT_DOMAIN_STEP:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          step: state.connectCurrentDomain.step - 1,
        },
      };
    case actionTypes.SET_CONNECT_CURRENT_DOMAIN_STEP:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          step: payload,
        },
      };
    case actionTypes.HELP_INSTRUCTIONS_VISIBLE:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          helpInstructionsVisibility: true,
        },
      };
    case actionTypes.HELP_INSTRUCTIONS_HIDDEN:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          helpInstructionsVisibility: false,
        },
      };
    case actionTypes.SET_SELECTED_DNS_PROVIDERS:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          selectedDNSProvider: payload,
        },
      };
    case actionTypes.SET_DOMAIN_NAME:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          domainName: payload,
        },
      };
    case deployAppActionTypes.DEPLOY_APP:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          isSubmitting: true,
          isSubmitted: false,
        },
      };
    case deployAppActionTypes.DEPLOY_APP_SUCCESS:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          isSubmitting: false,
          isSubmitted: true,
        },
      };
    case deployAppActionTypes.DEPLOY_APP_FAIL:
      return {
        ...state,
        connectCurrentDomain: {
          ...state.connectCurrentDomain,
          isSubmitting: false,
          isSubmitted: false,
        },
      };
    default:
      return state;
  }
};

export default domainReducer;
